module.exports = __webpack_public_path__ + "static/media/arrow-up.8571035b.svg";